import React from 'react';
import clsx from 'clsx';
import styles from './Tip.module.scss';
import { IconButton } from './IconButton.tsx';
import CloseIcon from '../../assets/icons/close-button-small.svg?react';

type TooltipProps = {
  bodyContent: React.ReactNode;
  titleContent?: React.ReactNode;
  footerContent?: React.ReactNode;
  className?: string;
  iconClassName?: string;
  showCancelButton?: boolean;
  closeTooltip?: () => void;
  isError?: boolean;
  testId?: string;
};

export const Tooltip = (props: TooltipProps) => {
  return (
    <div
      data-test-id={props.testId}
      className={clsx(
        styles.popper,
        props.isError && styles.error,
        props.className,
      )}
    >
      {props.titleContent && (
        <div className={styles.title}>{props.titleContent}</div>
      )}
      <div className={styles.rowContainer4}>
        {props.bodyContent}
        {props.showCancelButton && (
          <IconButton
            onClick={props.closeTooltip}
            type={'destroy'}
            iconClassName={styles.margin}
          >
            <CloseIcon className={props.iconClassName} />
          </IconButton>
        )}
      </div>
      {props.footerContent && (
        <div className={styles.title}>{props.footerContent}</div>
      )}
    </div>
  );
};
